import { motion } from "framer-motion";

export const InflectionCurve = ({ className = "", animate = true }) => {
  const anim = animate
    ? {
        initial: { pathLength: 0 },
        whileInView: { pathLength: 1 },
        viewport: { once: true, margin: "-60px" },
      }
    : {};
  return (
    <svg viewBox="0 0 400 170" fill="none" className={className} aria-hidden="true">
      <motion.path
        d="M4 160 C 90 154, 150 146, 210 100 C 268 56, 322 30, 386 12"
        stroke="#2BD9C7"
        strokeWidth="2"
        strokeLinecap="round"
        {...anim}
        transition={{ duration: 1.8, ease: "easeInOut" }}
      />
      <motion.path
        d="M366 6 L390 10 L372 30"
        stroke="#2BD9C7"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...anim}
        transition={{ duration: 0.5, delay: 1.6, ease: "easeOut" }}
      />
    </svg>
  );
};
